import { render, staticRenderFns } from "./WarrantyInfo.vue?vue&type=template&id=86fff3bc&scoped=true&"
import script from "./WarrantyInfo.vue?vue&type=script&lang=js&"
export * from "./WarrantyInfo.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyInfo.vue?vue&type=style&index=0&id=86fff3bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fff3bc",
  null
  
)

export default component.exports